import { defineStore } from "pinia";

interface PreviewState {
    scale: number;
    viewport: "desktop" | "tablet" | "mobile";
}

export const usePagePreviewStore = defineStore("page-preview", {
    state: (): PreviewState => ({
        scale: 1,
        viewport: "desktop",
    }),

    actions: {
        incrementScale() {
            this.scale = Math.min(1, this.scale + 0.05);
        },
        decrementScale() {
            this.scale = Math.max(0.2, this.scale - 0.05);
        },
        setScale(scale: number) {
            this.scale = Math.max(0.2, Math.min(1, scale));
        },
        setViewport(viewport: "desktop" | "tablet" | "mobile") {
            this.viewport = viewport;
        },
    },

    getters: {
        screenWidth: (state) => {
            switch (state.viewport) {
                case "mobile":
                    return "380px";
                case "tablet":
                    return "1024px";
                default:
                    return "100%";
            }
        },
    },
});
